import {RelayScriptRuleModifier} from '../enums/RelayScriptRuleModifier';
import {RelayScriptRuleRelay} from './RelayScriptRuleRelay';

export class RelayScriptRule {
  id: number;
  officeId: number;
  relayBoardId: number;
  timePeriodId: number;
  sensorId: number;
  isActive: boolean;
  modifier: RelayScriptRuleModifier;
  relayList: RelayScriptRuleRelay[];
  startDelay: number;
  endDelay: number;

  public constructor(init?: Partial<RelayScriptRule>) {
    Object.assign(this, init);
  }
}
